/* PetalHush product page (port of site/pdp.html). Native personalization, no app.
   Reads two JSON blobs rendered by sections/ph-product.liquid: the product ({{ product | json }}) and a config
   (strings, routes, add-on variant ids, money format). See theme/README.md for the cart flow.

   Cart flow (one click on "Add to bag"):
     1) add-on lines first, JSON POST /cart/add.js: back engraving (qty 1) and, in add-on mode, extra faces (qty n-1);
     2) the piece, multipart POST /cart/add (FormData from the product form: id, quantity, properties[...] incl. photo files);
     3) if (2) fails, every add-on line from (1) is removed again via /cart/change.js (quantity 0).
   Add-on lines and the piece share a hidden property "_Pair id" so the cart can keep them together. */
(function () {
  if (window.PetalHushPDP) return;
  window.PetalHushPDP = true;

  var ALLOWED = /^[A-Za-z0-9 &.'\-♥éèàüöäñçøåÉÈÀÜÖÄÑÇØÅ]*$/u;  // accents: [CONFIRM WITH FOUNDER] supplier font support
  var FILE_EXT = ['jpg', 'jpeg', 'png', 'heic', 'heif', 'webp'];
  // Meta pixel (2026-10-27, lead): one "photo_uploaded" customer event per product per page, on the first photo that
  // decodes. The theme only publishes it; the Shopify custom pixel "PetalHush Meta photo upload" (Settings > Customer
  // events, consent = Marketing) turns it into Meta PhotoUpload + CustomizeProduct. No pixel code in the theme.
  function phPhotoEvent(field) {
    try {
      var A = window.Shopify && window.Shopify.analytics;
      if (!A || typeof A.publish !== 'function' || (window.Shopify && window.Shopify.designMode)) return;
      var m = (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) || {};
      var key = String(m.id || location.pathname), sent = window.__phPhotoSent = window.__phPhotoSent || {};
      if (sent[key]) return;
      sent[key] = 1;
      var cents = null;
      (m.variants || []).forEach(function (v) { if (typeof v.price === 'number' && (cents === null || v.price < cents)) cents = v.price; });
      A.publish('photo_uploaded', {
        product_id: m.id ? String(m.id) : '', product_type: m.type || '', field: field || 'photo',
        value: cents === null ? null : cents / 100, currency: (window.Shopify.currency && window.Shopify.currency.active) || 'USD'
      });
    } catch (e) { /* tracking never breaks the upload */ }
  }
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  // Unconfirmed "[PLACEHOLDER: …]" copy: outlined in the theme editor, dropped entirely on the storefront (same rule as snippets/ph-text.liquid).
  var EDITOR = !!(window.Shopify && window.Shopify.designMode);
  function fmt(s) {
    s = String(s == null ? '' : s);
    if (!EDITOR && s.indexOf('[PLACEHOLDER') !== -1) return '';
    return esc(s).replace(/\[PLACEHOLDER[^\]]*\]/g, function (m) { return '<span class="ph-pending">' + m + '</span>'; });
  }
  function tpl(s, map) { return String(s || '').replace(/\{(\w+)\}/g, function (m, k) { return map[k] != null ? map[k] : m; }); }
  function money(cents, format) {
    var n = cents / 100, whole = Math.round(n) === n;
    var f = String(format || '${{amount}}').replace(/<[^>]*>/g, '');
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_no_decimals') return Math.round(n).toLocaleString('en-US');
      if (k === 'amount_with_comma_separator') return whole ? String(n) : n.toFixed(2).replace('.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return Math.round(n).toLocaleString('de-DE');
      return whole ? n.toLocaleString('en-US') : n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    });
  }
  function keepFile(input, file) {  // put a File back into an <input type=file> (QA R2)
    if (!file) { input.value = ''; return; }
    try { var dt = new DataTransfer(); dt.items.add(file); input.files = dt.files; } catch (e) { /* old browsers: input keeps its value */ }
  }

  /* P-102: the bag add got faster (theme/P-102-BAG-SPEED.md). The customer's photo goes up inside the multipart
     /cart/add: 5–30 s on a phone network. 1) Very big JPEG/PNG/WebP files (> 3 MB, or longest side > 4096 px) get a
     background copy as soon as they decode: longest side <= C.photoMaxPx (theme setting ph_photo_max_px, default 4096;
     "0" = off), JPEG q 0.88 on white, EXIF orientation applied by the browser; the copy is used only when it is at least
     25 % smaller. HEIC/HEIF always go as uploaded (iPhone HEIC is already smaller than any JPEG of it). Add to bag waits
     at most 3 s for a copy still being made (then the original goes) and swaps each photo in the FormData for its copy
     BEFORE the direct add or the set / B3 / AC modules get it. 2) The direct add uses XMLHttpRequest so the busy line
     shows the upload ("Adding to your bag… 45%") and an open bag a thin rose-gold bar. The first look keeps its own
     2048 px copy; type/size checks and the small-photo warning are unchanged. */
  var PH_SLIM_FROM = 3 * 1024 * 1024, PH_SLIM_GAIN = 0.75, PH_SLIM_WAIT = 3000;
  function phSlimMax(C) {
    var n = parseInt(C && C.photoMaxPx, 10);
    if (n === 0) return 0;   // off: always the original
    return n >= 1024 && n <= 8192 ? n : 4096;
  }
  function phSlimStart(photo, img, C) {   // photo = a field's state ({file, ...}); img = its decoded probe <img>
    var max = phSlimMax(C), f = photo && photo.file;
    if (!f) return;
    photo.slim = null;
    photo.slimP = new Promise(function (res) {
      try {
        var ext = (String(f.name || '').split('.').pop() || '').toLowerCase();
        var raster = /^image\/(jpeg|png|webp)$/.test(f.type) || (!f.type && /^(jpe?g|png|webp)$/.test(ext));
        var w = img.naturalWidth, h = img.naturalHeight, L = Math.max(w, h);
        if (!max || !raster || !L || (L <= max && f.size <= PH_SLIM_FROM)) return res(null);   // HEIC/HEIF and normal photos: as uploaded
        var k = Math.min(1, max / L), c = document.createElement('canvas');
        if (!c.getContext || !c.toBlob) return res(null);
        c.width = Math.max(1, Math.round(w * k)); c.height = Math.max(1, Math.round(h * k));
        var g = c.getContext('2d'); if (!g) return res(null);
        g.fillStyle = '#fff'; g.fillRect(0, 0, c.width, c.height); g.drawImage(img, 0, 0, c.width, c.height);
        c.toBlob(function (b) { c.width = c.height = 0; res(b && b.size && b.size <= f.size * PH_SLIM_GAIN ? b : null); }, 'image/jpeg', 0.88);
      } catch (e) { res(null); }
    }).then(function (b) { photo.slim = b; return b; });
  }
  function phSlimFd(fd, list) {   // list = [[field name, photo state], ...]; resolves once every copy is ready, or after 3 s
    var todo = list.filter(function (x) { return x[0] && x[1] && x[1].slimP && fd.has(x[0]); });
    var swap = function () {
      todo.forEach(function (x) {
        var p = x[1], cur = fd.get(x[0]);
        if (!p.slim || !cur || typeof cur === 'string' || cur.size !== p.file.size || cur.name !== p.file.name) return;   // only the file the copy was made from
        fd.set(x[0], p.slim, (String(p.file.name || '').replace(/\.[^.]*$/, '') || 'photo') + '.jpg');
      });
    };
    if (!todo.length) return Promise.resolve();
    return Promise.race([Promise.all(todo.map(function (x) { return x[1].slimP; })),
      new Promise(function (r) { setTimeout(r, PH_SLIM_WAIT); })]).then(swap, swap);
  }
  function phBusyPct(T, n) {   // n = 0–99 while the photo uploads; null = the plain busy line again
    var h = document.documentElement, txt = T.addingBag || 'Adding to your bag…';
    if (n == null) { h.removeAttribute('data-ph-pct'); h.style.removeProperty('--ph-adding-pct'); }
    else { txt += ' ' + n + '%'; h.setAttribute('data-ph-pct', ''); h.style.setProperty('--ph-adding-pct', n + '%'); }
    h.style.setProperty('--ph-adding-text', JSON.stringify(txt));
  }
  function phPost(url, fd, T) {   // the multipart add as XHR (upload progress); same JSON + errors as the fetch it replaces
    return new Promise(function (res, rej) {
      var x = new XMLHttpRequest(), last = -1;
      x.open('POST', url, true);
      x.setRequestHeader('X-Requested-With', 'XMLHttpRequest'); x.setRequestHeader('Accept', 'application/javascript');
      if (x.upload) x.upload.onprogress = function (e) {
        if (!e.lengthComputable || e.total < 262144) return;   // no photo in the body: no number
        var n = Math.min(99, Math.floor(e.loaded / e.total * 100));
        if (n !== last) { last = n; phBusyPct(T, n); }
      };
      x.onload = function () {
        phBusyPct(T, null);
        var j; try { j = JSON.parse(x.responseText); } catch (e) { return rej(e); }
        if (x.status < 200 || x.status >= 300 || !j || j.status) return rej(j || new Error('empty response'));
        res(j);
      };
      x.onerror = x.onabort = x.ontimeout = function () { phBusyPct(T, null); rej(new TypeError('Network request failed')); };
      x.send(fd);
    });
  }
  /* P-102 end */

  /* P-102b: photo pre-upload (theme/P-102-BAG-SPEED.md, phase 2; assets/ph-photo-up.js = window.PetalHushUp, loaded by
     the section when theme setting ph_photo_up_on is on). Once a photo decodes it goes up in the background; Add to bag
     then posts its URL instead of the file (about 1 s), waits for an unfinished upload with "Adding to your bag… n%",
     and keeps the phase 1 multipart add (Shopify upload) whenever the pre-upload is off, failed or stalled. */
  function phUpStart(photo, img, C, name) {
    try { if (window.PetalHushUp && C.upload) window.PetalHushUp.start(photo, img, C, name); } catch (e) { /* the Shopify upload stays */ }
  }
  function phUpDrop(name) {   // the field's photo was removed or replaced: its running upload stops (QA m4)
    try { if (window.PetalHushUp && window.PetalHushUp.drop) window.PetalHushUp.drop(name); } catch (e) { /* nothing to stop */ }
  }
  function phUpFd(fd, list, T) {   // → the photo fields still sent as files (phase 1 shrinks those next)
    if (!window.PetalHushUp || !list.length) return Promise.resolve(list);
    return window.PetalHushUp.apply(fd, list, function (n) { phBusyPct(T, n); }).catch(function () { return list; });
  }
  /* P-102b end */

  function init(root) {
    if (root.dataset.phReady) return;
    root.dataset.phReady = '1';
    var P = JSON.parse(root.querySelector('[data-ph-product-json]').textContent);
    var C = JSON.parse(root.querySelector('[data-ph-config]').textContent);
    var T = C.t;
    var $ = function (s) { return root.querySelector(s); };
    var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
    var form = $('[data-ph-form]');
    var pos = C.positions;
    var S = { photos: {}, font: 'serif', back: false, tried: false };
    $$('[data-ph-opt]').forEach(function (el, i) { if (!el.id) el.id = 'ph-opt-' + i + '-' + Math.random().toString(36).slice(2, 7); });

    /* ---------- variant ---------- */
    function selected() {
      var out = [];
      for (var p = 1; p <= P.options.length; p++) {
        var el = root.querySelector('[data-ph-opt="' + p + '"]:checked') || root.querySelector('select[data-ph-opt="' + p + '"]');
        out.push(el ? el.value : '');
      }
      return out;
    }
    function findVariant(opts) {
      if (opts.indexOf('') !== -1) return null;
      for (var i = 0; i < P.variants.length; i++) {
        var v = P.variants[i];
        if (v.options.every(function (o, j) { return o === opts[j]; })) return v;
      }
      return null;
    }
    function minPrice(p, value) {  // cheapest variant with option p = value, other chosen options kept
      var opts = selected(), best = null;
      P.variants.forEach(function (v) {
        var ok = v.options.every(function (o, j) { return j === p - 1 ? o === value : (opts[j] === '' || o === opts[j]); });
        if (ok && (best === null || v.price < best)) best = v.price;
      });
      return best;
    }
    function minVariantFor(p, value, strict) {  // cheapest variant with option p = value; strict: the other chosen options must match
      var opts = selected(), best = null;
      P.variants.forEach(function (v) {
        var ok = v.options.every(function (o, j) { return j === p - 1 ? o === value : (!strict || opts[j] === '' || o === opts[j]); });
        if (ok && (best === null || v.price < best.price)) best = v;
      });
      return best;
    }
    function priceHTML(v) {   // "$92 <s>$123</s>": compare-at only when above the price, grey strikethrough, no badge
      return esc(money(v.price, C.moneyFormat)) + (v.compare_at_price > v.price ? ' <s class="ph-compare">' + esc(money(v.compare_at_price, C.moneyFormat)) + '</s>' : '');
    }
    function count() {
      var el = root.querySelector('[data-ph-opt="' + pos.count + '"]:checked') || root.querySelector('[data-ph-count]:checked');
      return el ? +el.dataset.n || 1 : 1;
    }
    function family() {
      if (!pos.metal) return 'silver';
      var v = selected()[pos.metal - 1];
      return (C.metalFamily && C.metalFamily[v]) || 'silver';
    }
    function metalName() { return pos.metal ? selected()[pos.metal - 1] : ''; }
    function total(v) {
      if (!v) return null;
      var t = v.price, n = count();
      if (C.facesAddon && n > 1) t += (n - 1) * C.facesAddon.price;
      if (C.addon && S.back) t += C.addon.price;
      if (xsActive()) t += xsVariant().price;
      return t;
    }

    /* ---------- cross-sell: "Wear it on a chain" (own line item, follows the charm's material) ---------- */
    var xsOn = $('[data-ph-xs-on]'), xsWrap = $('[data-ph-xs-len-wrap]');
    function xsLen() {
      if (!C.xs || !C.xs.lenPos) return null;
      var el = root.querySelector('[data-ph-xs-len]:checked');
      return el ? el.value : C.xs.defaultLen;
    }
    function xsVariant() {
      if (!C.xs) return null;
      var metal = metalName(), len = xsLen();
      // Materials excluded from the cross-sell (default "10k": the 10K chain's material is unconfirmed, CLAUDE.md §4a)
      var ex = C.xs.excludeKw ? String(C.xs.excludeKw).split(',') : [];
      for (var k = 0; k < ex.length; k++) { var kwx = ex[k].trim(); if (kwx && metal.toLowerCase().indexOf(kwx) !== -1) return null; }
      for (var i = 0; i < C.xs.variants.length; i++) {
        var v = C.xs.variants[i];
        if ((!C.xs.metalPos || v.options[C.xs.metalPos - 1] === metal) && (!C.xs.lenPos || v.options[C.xs.lenPos - 1] === len)) return v.available === false ? null : v;
      }
      return null;
    }
    function xsActive() { return !!(xsOn && xsOn.checked && xsVariant()); }
    function paintXs() {
      if (!xsOn) return;
      var xv = xsVariant(), line = $('[data-ph-xs-line]');
      xsOn.disabled = !xv;
      if (!xv) { xsOn.checked = false; }
      if (xsWrap) xsWrap.hidden = !xsOn.checked;
      // No chain for this material: say so plainly instead of printing an empty price ("+.")
      var txt = xv ? fmt(tpl(T.xsLine, { chain: C.xs.title, material: metalName(), price: money(xv.price, C.moneyFormat) }))
                   : fmt(tpl(T.xsNone || '', { chain: C.xs.title, material: metalName() }));
      var kw = C.xs.noteKw;
      if (xv && kw && metalName().toLowerCase().indexOf(kw) !== -1 && C.xs.note) { var nt = fmt(C.xs.note); if (nt) txt += ' ' + nt; }
      if (line) line.innerHTML = txt;
    }
    if (xsOn) {
      if (C.xs.lenPos && !root.querySelector('[data-ph-xs-len]:checked')) {
        var lens = $$('[data-ph-xs-len]'), d0 = lens.filter(function (x) { return x.value === C.xs.defaultLen; })[0] || lens[1] || lens[0];
        if (d0) d0.checked = true;
      }
      xsOn.addEventListener('change', function () { paintXs(); update(); });
      $$('[data-ph-xs-len]').forEach(function (r) { r.addEventListener('change', function () { paintXs(); update(); }); });
    }

    /* ---------- deltas on pickers ---------- */
    /* ---------- count limits per material (e.g. 10K Solid Gold: 1 face) ---------- */
    function countInputs() { return pos.count ? $$('[data-ph-opt="' + pos.count + '"]') : $$('[data-ph-count]'); }
    function supports(metalVal, n) {
      if (!pos.metal || C.countMax < 2) return true;
      if (pos.count) {
        var cv = countInputs()[n - 1]; if (!cv) return false;
        return P.variants.some(function (v) { return v.options[pos.metal - 1] === metalVal && v.options[pos.count - 1] === cv.value; });
      }
      var md = String(metalVal).toLowerCase();
      var one = (C.oneFace || []).some(function (k) { k = k.trim(); return k && md.indexOf(k) !== -1; });
      return !(one && n > 1);
    }
    function maxFor(metalVal) { for (var n = C.countMax; n > 1; n--) if (supports(metalVal, n)) return n; return 1; }
    function countLabel(n) { var el = countInputs()[n - 1]; return el ? el.value : String(n); }
    function setCount(n) { var el = countInputs()[n - 1]; if (el) el.checked = true; }
    function paintLimits() {
      var m = metalName(), n = count();
      countInputs().forEach(function (el) { el.disabled = !supports(m, +el.dataset.n); });
      // P-017 material cards: price (+ compare-at) for the other options chosen; "from" until they all are (ring size)
      var opts = selected(), allOther = opts.every(function (o, j) { return j === pos.metal - 1 || o !== ''; });
      $$('[data-ph-opt="' + pos.metal + '"]').forEach(function (el) {
        var na = !supports(el.value, n), card = el.closest('.ph-mpill, .ph-sw');
        if (card) card.classList.toggle('is-na', na);
        var exact = minVariantFor(pos.metal, el.value, true), v = exact || minVariantFor(pos.metal, el.value, false);
        var avail = P.variants.some(function (w) { return w.options[pos.metal - 1] === el.value && w.available !== false; });
        if (v) el.dataset.from = money(v.price, C.moneyFormat);
        var sm = card && card.querySelector('[data-ph-mprice]');
        if (sm && v) sm.innerHTML = avail ? priceHTML(v) : esc(T.unavailableShort);
        el.setAttribute('aria-label', el.value + ', ' + (avail ? (exact && allOther ? '' : T.fromLower + ' ') + el.dataset.from : T.unavailableShort) + (na ? ', ' + tpl(T.onlySuffix, { count: countLabel(maxFor(el.value)) }) : ''));
      });
      var lim = $('[data-ph-count-limit]');
      if (lim) { var mx = maxFor(m); lim.textContent = mx < C.countMax ? tpl(T.limitNote, { metal: m, count: countLabel(mx) }) : ''; }
      var d = $('[data-ph-metal-desc]'); if (d && C.metalDesc) d.innerHTML = fmt(C.metalDesc[m] || '');
      var ym = $('[data-ph-your-material]');
      if (ym && C.metalDesc) { var yd = fmt(C.metalDesc[m] || ''); ym.innerHTML = yd ? '<b>' + esc(tpl(T.yourMaterial, { metal: m })) + '</b> ' + yd : ''; }
    }
    // QA M3: switching to a material with fewer faces drops the count, keeps the other photos (inputs are only
    // disabled, never cleared) and says so. Switching back re-enables them with their files.
    function enforceLimit() {
      var m = metalName(), n = count();
      if (supports(m, n)) return;
      var mx = maxFor(m), saved = false;
      for (var i = mx + 1; i <= n; i++) if (S.photos[i]) saved = true;
      setCount(mx);
      announce(tpl(T.limitAnnounce, { metal: m, count: countLabel(mx) }) + (saved ? ' ' + T.photosSaved : ''), 0);
    }
    function paintDeltas() {
      var cnt = pos.count ? $$('[data-ph-opt="' + pos.count + '"]') : $$('[data-ph-count]');
      if (cnt.length) {
        var first = pos.count ? minPrice(pos.count, cnt[0].value) : 0;
        cnt.forEach(function (i) {
          var d = pos.count ? (minPrice(pos.count, i.value) || 0) - (first || 0) : (+i.dataset.n - 1) * (C.facesAddon ? C.facesAddon.price : 0);
          i.parentNode.querySelector('[data-ph-delta]').textContent = d > 0 ? '+' + money(d, C.moneyFormat) : T.included;
        });
      }
      var mn = $('[data-ph-metal-name]');
      if (mn) mn.textContent = metalName() ? '· ' + metalName() : '';
    }

    /* ---------- count-dependent fields (inputs past n are disabled, never rebuilt: QA R1) ---------- */
    function applyCount() {
      var n = count();
      $$('[data-ph-up]').forEach(function (up) {
        var i = +up.dataset.phUp, on = i <= n;
        up.hidden = !on;
        up.querySelector('input[type=file]').disabled = !on;
      });
      $$('[data-ph-name-slot]').forEach(function (f) {
        var on = +f.dataset.phNameSlot <= n;
        f.hidden = !on;
        f.querySelector('input').disabled = !on;
      });
      $$('[data-ph-name-sfx]').forEach(function (x) { x.hidden = n < 2; });
      var st = $('[data-ph-s1-title]'); if (st) st.textContent = n > 1 ? T.photoTitleN : T.photoTitle1;
      var one = $('[data-ph-scale="one"]'), many = $('[data-ph-scale="many"]');
      if (one && many) { one.hidden = n > 1; many.hidden = n < 2; }
      // Supplier-confirmed sizes print without a placeholder: necklace 1 face (18 mm); bracelet every count (18 mm)
      var mm = n > 1 ? C.mm.many : C.mm.one;
      var sizeOk = n > 1 ? C.mm.manyConfirmed : C.mm.oneConfirmed;
      var shown = C.mm.text || mm;   // a range like "13–15" is shown instead of the drawing size
      var pend = sizeOk ? '' : tpl(C.mm.pendTpl, { mm: shown });
      $$('[data-ph-mm-text]').forEach(function (x) { x.innerHTML = fmt(String(x.dataset.tpl).replace(/\{mm\}/g, shown).replace('{pend}', pend).trim()); });
      var prop = $('[data-ph-count-prop]');
      if (prop) { var c = root.querySelector('[data-ph-count]:checked'); if (c) prop.value = c.value; }
    }

    /* ---------- gallery ---------- */
    var track = $('[data-ph-track]'), thumbs = $('[data-ph-thumbs]'), live = $('[data-ph-live]');
    function slides() { return $$('[data-ph-track] .ph-slide').filter(function (s) { return !s.hidden; }); }
    function applyMetalSlides() {
      var f = family();
      $$('[data-metal-only],[data-metal-not]').forEach(function (s) {
        s.hidden = (s.dataset.metalOnly && s.dataset.metalOnly !== f) || (s.dataset.metalNot && s.dataset.metalNot === f);
      });
    }
    function renderThumbs() {
      var list = slides();
      thumbs.innerHTML = list.map(function (s, i) {
        var img = s.querySelector('img');
        var inner = s === live ? '<span class="ph-t-ph">' + esc(T.thumbYours) + '</span>'
          : img ? '<img src="' + esc(img.currentSrc || img.src) + '" alt="" loading="lazy" width="58" height="58">' : '<span class="ph-t-ph">·</span>';
        return '<button type="button" aria-label="' + esc(tpl(T.thumbShow, { i: i + 1, n: list.length }) + (s === live ? ', ' + T.thumbPreview : '')) + '" aria-current="' + (i === 0) + '">' + inner + '</button>';
      }).join('');
      Array.prototype.forEach.call(thumbs.querySelectorAll('button'), function (b, i) { b.addEventListener('click', function () { goTo(i); }); });
    }
    function goTo(i) { track.scrollTo({ left: i * track.clientWidth, behavior: reduced ? 'auto' : 'smooth' }); }
    track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / track.clientWidth);
      Array.prototype.forEach.call(thumbs.querySelectorAll('button'), function (b, j) { b.setAttribute('aria-current', j === i); });
    }, { passive: true });
    track.addEventListener('keydown', function (e) {
      var i = Math.round(track.scrollLeft / track.clientWidth);
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(Math.min(i + 1, slides().length - 1)); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(Math.max(i - 1, 0)); }
    });
    function showVariantMedia(v) {
      if (!v || !v.featured_media) return;
      var list = slides();
      for (var i = 0; i < list.length; i++) if (list[i].dataset.mediaId == v.featured_media.id) { goTo(i); return; }
    }
    function showLive(scroll) {
      if (!live || !Object.keys(S.photos).some(function (k) { return S.photos[k]; })) return;
      if (live.hidden) { live.hidden = false; renderThumbs(); }
      renderPreview($('[data-ph-pv-gallery]'), 300);
      if (scroll && window.matchMedia('(min-width: 900px)').matches) goTo(0);
    }

    /* ---------- photos: properties[Photo n] ---------- */
    function upEls(i) {
      var up = root.querySelector('[data-ph-up="' + i + '"]');
      return { up: up, input: up.querySelector('input[type=file]'), msg: up.querySelector('.ph-msg') };
    }
    function setMsg(i, text, kind) {
      var e = upEls(i);
      e.msg.className = 'ph-msg' + (kind ? ' is-' + kind : '');
      e.msg.textContent = text;
      e.input.setAttribute('aria-invalid', kind === 'err');
    }
    function paintUp(i) {
      var e = upEls(i), p = S.photos[i];
      e.up.classList.toggle('has-photo', !!p);
      e.up.querySelector('.ph-ic').innerHTML = p && p.ok ? '<img src="' + p.url + '" alt="">'
        : '<svg viewBox="0 0 24 24"><path d="M4 8h3l2-2.5h6L17 8h3v11H4z"/><circle cx="12" cy="13" r="3.5"/></svg>';
      e.up.querySelector('small').textContent = p ? p.name : tpl(T.uploadHint, { mb: C.maxMB });
      e.up.querySelector('.ph-act').textContent = p ? T.replace : T.upload;
    }
    function handleFile(i, f) {
      var e = upEls(i);
      var ext = (f.name.split('.').pop() || '').toLowerCase();
      var typeOk = /^image\/(jpeg|png|heic|heif|webp)$/.test(f.type);
      var reject = function (t) {  // QA R2: a rejected file never replaces a good one in the form
        var prev = S.photos[i] && S.photos[i].file;
        keepFile(e.input, prev || null);
        setMsg(i, t, prev ? 'warn' : 'err');
        if (prev) e.input.setAttribute('aria-invalid', false);
      };
      if (FILE_EXT.indexOf(ext) === -1 && !typeOk) return reject(T.badType);
      if (f.size > C.maxMB * 1024 * 1024) return reject(tpl(T.tooBig, { mb: C.maxMB }));
      phUpDrop(e.input.name);   // P-102b: the old photo's upload stops
      if (S.photos[i]) URL.revokeObjectURL(S.photos[i].url);
      var url = URL.createObjectURL(f);  // preview only; the file itself posts with the form
      S.photos[i] = { url: url, name: f.name, ok: false, file: f };
      setMsg(i, T.adding, '');
      var probe = new Image();
      probe.onload = function () {
        if (!S.photos[i] || S.photos[i].url !== url) return;
        S.photos[i].ok = true;
        phPhotoEvent('photo_' + (i + 1));
        phSlimStart(S.photos[i], probe, C);   // P-102: the smaller copy for the bag
        phUpStart(S.photos[i], probe, C, upEls(i).input.name);   // P-102b: pre-upload
        if (probe.naturalWidth < C.minPx || probe.naturalHeight < C.minPx) setMsg(i, T.tooSmall, 'warn');
        else setMsg(i, T.added, '');
        paintUp(i); update(); showLive(true);
      };
      probe.onerror = function () {
        if (!S.photos[i] || S.photos[i].url !== url) return;
        setMsg(i, T.noPreview, ''); paintUp(i); update(); showLive(true);
      };
      probe.src = url;
      paintUp(i); update();
    }
    $$('[data-ph-up]').forEach(function (up) {
      var i = +up.dataset.phUp, input = up.querySelector('input[type=file]'), drop = up.querySelector('.ph-drop');
      input.addEventListener('change', function () { if (input.files[0]) handleFile(i, input.files[0]); });
      ['dragenter', 'dragover'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-drag'); }); });
      ['dragleave', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-drag'); }); });
      drop.addEventListener('drop', function (e) {
        var f = e.dataTransfer.files[0]; if (!f) return;
        keepFile(input, f);
        handleFile(i, f);
      });
      up.querySelector('.ph-rm').addEventListener('click', function () {
        phUpDrop(input.name);   // P-102b
        if (S.photos[i]) URL.revokeObjectURL(S.photos[i].url);
        S.photos[i] = null; input.value = '';
        paintUp(i); setMsg(i, '', ''); update(); input.focus();
      });
    });

    /* ---------- text properties ---------- */
    var srTimer;
    function announce(t, delay) { clearTimeout(srTimer); srTimer = setTimeout(function () { $('[data-ph-sr]').textContent = t; }, delay == null ? 500 : delay); }
    function labelOf(el) { var l = el.labels && el.labels[0]; return l ? l.firstChild.textContent.trim() : ''; }
    $$('[data-ph-text]').forEach(function (el) {
      var max = +el.maxLength, cnt = root.querySelector('[data-ph-count-of="' + el.id + '"]'), msg = document.getElementById(el.id + '-msg');
      var sync = function (speak) {
        var len = Array.from(el.value).length, left = max - len;
        cnt.textContent = len + '/' + max;
        cnt.classList.toggle('is-lim', left <= 0);
        var err = el.hasAttribute('data-engrave') && !ALLOWED.test(el.value) ? T.charset : '';
        msg.textContent = err;
        el.setAttribute('aria-invalid', !!err);
        if (speak && !err) {
          if (left === 0) announce(tpl(T.limitReached, { max: max }));
          else if (left <= 3) announce(tpl(T.charsLeft, { n: left }));
        }
      };
      el.addEventListener('input', function () { sync(true); update(); });
      sync(false);
    });
    $$('[data-ph-font]').forEach(function (r) { r.addEventListener('change', function () { S.font = r.dataset.phFont; update(); }); });
    var back = $('[data-ph-back]');
    if (back) back.addEventListener('change', function () {
      S.back = back.checked;
      var wrap = $('[data-ph-back-wrap]'), field = wrap.querySelector('input');
      wrap.hidden = !back.checked; field.disabled = !back.checked;   // disabled fields don't post
      if (back.checked) field.focus();
      update();
    });

    /* ---------- live preview ---------- */
    function names() { return $$('[data-ph-name-slot]').filter(function (f) { return !f.hidden; }).map(function (f) { return f.querySelector('input').value; }); }
    function insideVal() { var f = $('[data-ph-role="inside"] input'); return f ? f.value : ''; }
    function faceHTML(i) {
      var p = S.photos[i];
      if (p && p.ok) return '<div class="ph-f"><img src="' + p.url + '" alt=""></div>';
      if (p) return '<div class="ph-f"><span class="ph-nopv">' + esc(T.photoAdded) + '</span></div>';
      return '<div class="ph-f"><img src="' + esc(C.sampleImage) + '" alt="" loading="lazy"></div>';
    }
    function designImage() {   // design mode: the product's own image for the selected material
      var v = findVariant(selected()), src = null;
      if (v && v.featured_image && v.featured_image.src) src = v.featured_image.src;
      if (!src && pos.metal) {   // ring size not chosen yet: any variant in that material with an image
        var m = metalName();
        for (var i = 0; i < P.variants.length; i++) { var w = P.variants[i]; if (w.options[pos.metal - 1] === m && w.featured_image) { src = w.featured_image.src; break; } }
      }
      if (src) return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=600';
      return C.designImage;
    }
    function renderPreview(el, d) {
      if (!el) return;
      if (C.design) {
        var src = designImage(), nm0 = names().filter(Boolean).join(' & ') || insideVal();
        el.innerHTML = (src ? '<img class="ph-design-pv" src="' + esc(src) + '" alt="' + esc(tpl(T.designAlt, { title: C.title, material: metalName() })) + '" width="600" height="600" loading="lazy">' : '') +
          (nm0 ? '<p class="ph-design-name' + (S.font === 'sans' ? ' is-sans' : '') + '"></p>' : '');
        var nmEl = el.querySelector('.ph-design-name'); if (nmEl) nmEl.textContent = nm0;
        return;
      }
      var n = count(), any = Object.keys(S.photos).some(function (k) { return S.photos[k]; }), nm = names(), inner = '', i;
      if (C.kind === 'necklace') {
        var fs = ''; for (i = 1; i <= n; i++) fs += faceHTML(i);
        inner = '<div class="ph-med ph-med6" style="--d:' + d * (n > 1 ? 1.08 : 1) + 'px"><div class="ph-lobes"><div class="ph-disc"><div class="ph-faces">' + fs + '</div><div class="ph-nm"></div></div></div></div>';
      } else if (C.kind === 'bracelet') {
        var md = Math.round(d * (n === 1 ? 0.62 : n === 2 ? 0.5 : 0.4)), ms = '';
        for (i = 1; i <= n; i++) ms += '<div class="ph-med ph-med6 no-bail" style="--d:' + md + 'px"><div class="ph-lobes"><div class="ph-disc"><div class="ph-faces">' + faceHTML(i) + '</div><div class="ph-nm" data-i="' + (i - 1) + '"></div></div></div></div>';
        inner = '<div class="ph-chainrow" style="--d:' + md + 'px">' + ms + '</div>';
      } else {
        inner = '<div class="ph-ringpv" style="--d:' + d + 'px"><div class="ph-med no-bail"><div class="ph-disc"><div class="ph-faces">' + faceHTML(1) + '</div></div></div></div>' +
          '<p class="ph-inside">' + esc(T.insidePv) + ' <i class="' + (S.font === 'sans' ? 'is-sans' : '') + '"></i></p>';
      }
      var aria = tpl(T.previewAria, { metal: metalName(), photo: any ? T.yourPhoto : T.samplePhoto });
      el.innerHTML = '<div class="ph-pv' + (S.font === 'sans' ? ' is-sans' : '') + '" data-metal="' + family() + '" role="img" aria-label="' + esc(aria) + '">' + inner + '</div>' +
        (any ? '' : '<p class="ph-fine" style="margin-top:12px">' + esc(T.sampleNote) + '</p>');
      if (C.kind === 'necklace') el.querySelector('.ph-nm').textContent = nm.filter(Boolean).join(' & ');
      if (C.kind === 'bracelet') Array.prototype.forEach.call(el.querySelectorAll('.ph-nm'), function (x) { x.textContent = nm[+x.dataset.i] || ''; });
      if (C.kind === 'ring') el.querySelector('.ph-inside i').textContent = insideVal() || '—';
    }

    /* ---------- validation (pure) ---------- */
    function problems() {
      if (C.isChain) {
        var v0 = findVariant(selected());
        if (v0 && v0.available !== false) return [];
        var f0 = root.querySelector('[data-ph-opt]:checked') || root.querySelector('[data-ph-opt]');
        return [{ id: f0 ? f0.id : '', kind: 'variant', t: T.unavailable }];
      }
      var out = [], n = count();
      for (var i = 1; i <= (C.design ? 0 : n); i++) {   // design mode: no photos
        var e = upEls(i);
        if (!S.photos[i] || !e.input.files || !e.input.files.length) {
          out.push({ id: e.input.id, kind: 'photo', i: i, t: (C.kind === 'ring' || C.countMax < 2) ? T.missingPhoto1 : tpl(T.missingPhotoN, { label: e.input.dataset.label.toLowerCase() }) });
        }
      }
      $$('[data-engrave]').forEach(function (el) {
        if (!el.disabled && !ALLOWED.test(el.value)) out.push({ id: el.id, t: tpl(T.checkChars, { label: labelOf(el) }) });
      });
      if (S.back) { var bt = $('[data-ph-role="back"] input'); if (bt && !bt.value.trim()) out.push({ id: bt.id, kind: 'back', t: T.backMissing }); }
      var size = $('[data-ph-size]');
      if (size && !size.value) out.push({ id: size.id, kind: 'size', t: T.sizeMissing });
      else {
        var v = findVariant(selected());
        if (!v || v.available === false) {
          var first = root.querySelector('[data-ph-opt]:checked') || root.querySelector('[data-ph-opt]');
          out.push({ id: first ? first.id : '', kind: 'variant', t: T.unavailable });
        }
      }
      return out;
    }
    function showErrors(list, inline) {
      var box = $('[data-ph-error]');
      if (!list.length) { box.innerHTML = ''; return; }
      box.innerHTML = '<b>' + esc(T.errHeading) + '</b><ul>' + list.map(function (p) { return '<li><a href="#' + p.id + '" data-focus="' + p.id + '">' + esc(p.t) + '</a></li>'; }).join('') + '</ul>';
      Array.prototype.forEach.call(box.querySelectorAll('[data-focus]'), function (a) {
        a.addEventListener('click', function (e) { e.preventDefault(); focusField(document.getElementById(a.dataset.focus)); });
      });
      if (!inline) return;
      list.forEach(function (p) {
        if (p.kind === 'photo') setMsg(p.i, p.t, 'err');
        if (p.kind === 'back') { var b = document.getElementById(p.id); document.getElementById(p.id + '-msg').textContent = T.backMissingInline; b.setAttribute('aria-invalid', true); }
        if (p.kind === 'size') { var s = document.getElementById(p.id); s.parentNode.querySelector('.ph-msg').textContent = T.sizeMissingInline; s.setAttribute('aria-invalid', true); }
      });
    }
    function focusField(el) {
      if (!el) return;
      var box = el.closest('.ph-up, .ph-tf, .ph-field, .ph-opt');
      if (box) box.scrollIntoView({ block: 'center', behavior: reduced ? 'auto' : 'smooth' });
      el.focus({ preventScroll: true });
    }

    /* ---------- summary, price, state ---------- */
    // Pre-made designs: the returns line follows the engraving choice (any name, back message or inside engraving typed)
    function paintReturns() {
      var plain = $('[data-ph-ret="plain"]'), eng = $('[data-ph-ret="engraved"]');
      if (!plain || !eng) return;
      var has = $$('[data-engrave]').some(function (el) { return !el.disabled && el.value.trim() !== ''; });
      plain.hidden = has; eng.hidden = !has;
    }
    root.addEventListener('input', function (e) { if (e.target.matches && e.target.matches('[data-engrave]')) paintReturns(); });
    root.addEventListener('change', paintReturns);
    function update() {
      paintReturns();
      var opts = selected(), v = findVariant(opts), n = count(), sum = T.sum, i;
      var idInput = $('[data-ph-variant-id]');
      if (idInput) idInput.value = v ? v.id : '';
      var tt = total(v), sizeOpen = $('[data-ph-size]') && !$('[data-ph-size]').value;
      // size not chosen yet (ring): show the chosen material's price; a missing combination: "Unavailable"
      var openMin = sizeOpen && pos.metal ? minPrice(pos.metal, metalName()) : null;
      var priceTxt = tt !== null ? money(tt, C.moneyFormat) : (sizeOpen ? (openMin !== null ? money(openMin, C.moneyFormat) : null) : T.unavailableShort);
      var totalEl = $('[data-ph-total]'); if (totalEl && priceTxt) totalEl.textContent = priceTxt;
      var tl = $('[data-ph-total-label]'); if (tl && !C.isChain) tl.textContent = xsActive() ? T.totalWith : T.totalLabel;
      var stp = $('[data-ph-st-price]'); if (stp && !C.waitlist && priceTxt) stp.textContent = priceTxt;
      var stb = $('[data-ph-st-btn]'); if (stb && !C.waitlist) stb.setAttribute('aria-label', T.addToBag + (tt !== null ? ', ' + money(tt, C.moneyFormat) : ''));
      var have = 0; for (i = 1; i <= n; i++) if (S.photos[i]) have++;
      var consent = $('[data-ph-consent]'); if (consent) consent.disabled = have === 0;   // _Consent posts only once a photo is added

      var dl = $('[data-ph-summary]');
      if (dl) {
        var rows = [];
        var add = function (k, val, missing) { rows.push('<dt>' + esc(k) + '</dt><dd' + (missing ? ' class="is-missing"' : '') + '>' + val + '</dd>'); };
        if (pos.metal) add(sum.metal, esc(metalName()));
        if (C.countMax > 1) add(C.countLegend, esc(n) + (n > 1 && C.facesAddon ? ' · +' + money((n - 1) * C.facesAddon.price, C.moneyFormat) : ''));
        P.options.forEach(function (name, j) {
          var p = j + 1; if (p === pos.metal || p === pos.count) return;
          add(typeof name === 'string' ? name : name.name, opts[j] ? esc(opts[j]) : sum.notChosen, !opts[j]);
        });
        if (!C.design) add(n > 1 ? sum.photos : sum.photo, have >= n ? (n > 1 ? esc(tpl(sum.addedN, { n: n })) : esc(sum.addedOne)) : esc(tpl(sum.partial, { have: have, n: n })), have < n);
        if (C.kind !== 'ring') { var nm = names().filter(Boolean); add(n > 1 ? sum.names : sum.name, nm.length ? esc(nm.join(' · ')) : esc(sum.none)); }
        else add(sum.inside, insideVal() ? esc(insideVal()) : esc(sum.none));
        var fontIn = root.querySelector('[data-ph-font]:checked'); add(sum.font, esc(fontIn ? fontIn.value : ''));
        if (C.addon) {
          var bt = $('[data-ph-role="back"] input');
          add(sum.back, S.back ? (bt && bt.value ? esc(bt.value) + ' · +' + money(C.addon.price, C.moneyFormat) : esc(sum.notWritten)) : esc(sum.none), S.back && !(bt && bt.value));
        }
        var notes = $('[data-ph-role="notes"] textarea'); add(sum.notes, notes && notes.value ? esc(sum.addedOne) : esc(sum.none));
        if (xsActive()) { var xv = xsVariant(), xl = xsLen(); add(T.sumChain, esc(C.xs.title) + (xl ? ' · ' + esc(xl) : '') + ' · ' + money(xv.price, C.moneyFormat)); }
        dl.innerHTML = rows.join('');
      }
      renderPreview($('[data-ph-pv-review]'), 200);
      if (live && !live.hidden) renderPreview($('[data-ph-pv-gallery]'), 300);

      var s1 = C.design ? !!v : have >= n, s2 = s1 && !problems().some(function (p) { return p.kind !== 'photo'; });
      [['1', s1], ['2', s2]].forEach(function (x) {
        var a = root.querySelector('[data-step="' + x[0] + '"]'); if (!a) return;
        a.classList.toggle('is-done', x[1]);
        a.querySelector('[data-ph-done]').textContent = x[1] ? ' ' + T.done : '';
      });
      if (S.tried) showErrors(problems(), false);
    }
    function onOptionChange(e) {
      if (e && e.target && +e.target.dataset.phOpt === pos.metal) enforceLimit();
      applyCount(); applyMetalSlides(); paintDeltas(); paintLimits();
      var v = findVariant(selected());
      paintPriceRow(); paintIllus();
      if (v && window.history.replaceState && !C.waitlist) {
        var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState(null, '', u.toString());
      }
      var size = $('[data-ph-size]'); if (size && size.value) { size.removeAttribute('aria-invalid'); size.parentNode.querySelector('.ph-msg').textContent = ''; }
      renderThumbs(); showVariantMedia(v); paintXs(); update();
    }
    $$('[data-ph-opt],[data-ph-count]').forEach(function (el) { el.addEventListener('change', onOptionChange); });
    // QA r4 nit 5 + P-017: the price row shows the chosen variant's price (+ compare-at), as on the breed PDP, from the
    // first paint. Ring with no size yet: "From" + the chosen material's lowest price.
    function paintPriceRow() {
      var pr = root.querySelector('.ph-price-row .ph-price'); if (!pr) return;
      var v = findVariant(selected()), lead = '';
      if (!v && pos.metal) { v = minVariantFor(pos.metal, metalName(), true) || minVariantFor(pos.metal, metalName(), false); lead = T.from + ' '; }
      if (v) pr.innerHTML = esc(lead) + priceHTML(v);
    }
    // Colour note on the gallery (breed PDP F1): materials whose photos show another metal (setting illustrative_keywords)
    function paintIllus() {
      var note = $('[data-ph-illus]'); if (!note) return;
      var md = metalName().toLowerCase();
      note.hidden = !md || !(C.illustrative || []).some(function (k) { k = String(k).trim(); return k && md.indexOf(k) !== -1; });
    }

    /* ---------- size chart: the scale-drawing product image in a native dialog (snippets/ph-size-guide) ---------- */
    var sizeBtn = $('[data-ph-sizechart]'), sizeDlg = $('[data-ph-sizeguide]');
    if (sizeBtn && sizeDlg && sizeDlg.showModal) {
      sizeBtn.addEventListener('click', function () { sizeDlg.showModal(); });
      sizeDlg.addEventListener('click', function (e) { if (e.target === sizeDlg || e.target.closest('[data-ph-sizeclose]')) sizeDlg.close(); });
      sizeDlg.addEventListener('close', function () { sizeBtn.focus(); });
    } else if (sizeBtn) sizeBtn.hidden = true;

    /* ---------- add to bag ---------- */
    function postJSON(url, body) {
      return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw j; return j; }); });
    }
    // Horizon: header cart icon and drawer listen for Shopify's standard 'shopify:cart:lines-update' event
    // (module '@shopify/events' from Horizon's import map). Dawn: re-render #cart-icon-bubble.
    // window.PetalHushEvents = import('@shopify/events') promise, set by an inline script in sections/ph-product.liquid:
    // a literal import() in this asset is rewritten to require() by Shopify's asset minifier and throws (P-016 r2).
    function cartSections() {   // Horizon cart drawer / cart page sections, rendered by Shopify with the add (like Horizon's own forms)
      var ids = Array.prototype.map.call(document.querySelectorAll('cart-items-component[data-section-id]'), function (n) { return n.dataset.sectionId; });
      return ids.filter(function (x, i) { return x && ids.indexOf(x) === i; }).slice(0, 5);
    }
    /* P-098: same as petalhush-breed.js. While an add runs both buttons show T.addingBag and ignore taps, and an open
       drawer shows it instead of "Your bag is empty"; afterwards an empty-looking drawer is re-rendered by Horizon, and
       if it still looks empty (or the theme events never load) the shopper goes to the cart page. */
    var busyBtns = function () { return [$('[data-ph-add]'), $('[data-ph-st-btn]')].filter(Boolean); };
    function busyOn() {
      S.adding = true;
      var h = document.documentElement, txt = T.addingBag || 'Adding to your bag…';
      busyBtns().forEach(function (x) { x.classList.add('is-adding'); x.setAttribute('aria-disabled', 'true'); x.setAttribute('aria-busy', 'true'); x.setAttribute('aria-label', txt); });
      h.style.setProperty('--ph-adding-text', JSON.stringify(txt)); h.setAttribute('data-ph-adding', '');
      var st = $('[data-ph-added]'); if (st) st.textContent = txt;
    }
    function busyOff(keepDrawer) {
      S.adding = false;
      busyBtns().forEach(function (x) { x.classList.remove('is-adding'); x.removeAttribute('aria-disabled'); x.removeAttribute('aria-busy'); x.removeAttribute('aria-label'); });
      if (!keepDrawer) document.documentElement.removeAttribute('data-ph-adding');
    }
    function goCart() { document.documentElement.removeAttribute('data-ph-adding'); window.location.href = C.routes.cart; }
    function watchDrawer(E, lines, count) {
      var td = document.getElementById('cart-drawer'), t0 = Date.now(), again = false, tAgain = 0;
      var done = function () { document.documentElement.removeAttribute('data-ph-adding'); };
      if (!td || !count) return done();
      (function check() {
        if (!td.querySelector('.cart-drawer--empty')) return done();
        var dt = Date.now() - t0;
        if (!again && dt > 1500) {
          again = true; tAgain = Date.now();
          if (E) try { var d = E.createPromise(); document.dispatchEvent(new E({ action: 'update', context: 'product', lines: [], promise: d.promise }));
            d.resolve({ cart: null, detail: { itemCount: count, source: 'petalhush-product', didError: false } }); } catch (e) { /* cart page below */ }
        }
        if (again && Date.now() - tAgain > 4500) return goCart();   // 4.5 s after the re-render was asked (timers freeze in a backgrounded tab)
        setTimeout(check, 150);
      })();
    }
    function notifyTheme(lines, sections) {
      var dawn = function () {
        if (document.getElementById('cart-drawer')) return goCart();   // P-098: Horizon without its events module
        document.documentElement.removeAttribute('data-ph-adding'); refreshBagIcon();
      };
      var hasMap = !!document.querySelector('script[type="importmap"]');
      if (!hasMap || !window.PetalHushEvents) return dawn();
      Promise.resolve(window.PetalHushEvents).then(function (m) {
        if (!m) return dawn();
        var E = m.CartLinesUpdateEvent; if (!E || !E.createPromise) return dawn();
        var d = E.createPromise();
        document.dispatchEvent(new E({ action: 'add', context: 'product', lines: lines, promise: d.promise }));
        fetch(C.routes.root.replace(/\/$/, '') + '/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
          d.resolve({ cart: E.createCartFromAjaxResponse ? E.createCartFromAjaxResponse(c) : null,
                      detail: { items: c.items, itemCount: c.item_count, source: 'petalhush-product', sections: sections || undefined, didError: false } });
          setTimeout(function () { var td = document.getElementById('cart-drawer'); if (td && typeof td.open === 'function' && !td.isOpen) td.open(); }, 60);   // founder r4: drawer slides out
          watchDrawer(E, lines, c.item_count);   // P-098
        }).catch(function (e) { d.reject(e); goCart(); });
      }).catch(dawn);
    }
    function refreshBagIcon() {
      var bubble = document.getElementById('cart-icon-bubble');   // Dawn header cart icon
      if (!bubble) return;
      fetch(C.routes.root + '?sections=cart-icon-bubble').then(function (r) { return r.json(); }).then(function (j) {
        var html = j['cart-icon-bubble']; if (!html) return;
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var fresh = tmp.querySelector('.shopify-section') || tmp; bubble.innerHTML = fresh.innerHTML;
      }).catch(function () {});
    }
    function addToBag() {
      var fd = new FormData(form), v = findVariant(selected()), n = count();
      Array.from(fd.entries()).forEach(function (e) { if (e[0].indexOf('properties[') === 0 && e[1] === '') fd.delete(e[0]); });
      var sku = v && v.sku ? v.sku : (v ? String(v.id) : '');
      var name1 = (names()[0] || '').trim();
      var pair = 'ph' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
      var items = [];
      if (C.addon && S.back) items.push({ id: C.addon.id, quantity: 1, properties: { '_Back engraving for': [sku, name1].filter(Boolean).join(' · '), '_Pair id': pair } });
      if (C.facesAddon && n > 1) items.push({ id: C.facesAddon.id, quantity: n - 1, properties: { '_Extra faces for': [sku, n + ' ' + C.countLegend].join(' · '), '_Per piece': String(n - 1), '_Pair id': pair } });
      if (items.length) fd.append('properties[_Pair id]', pair);   // fee lines only; the chain is a standalone item
      if (xsActive()) items.push({ id: xsVariant().id, quantity: 1, properties: { '_Worn with': sku } });
      var btn = $('[data-ph-add]'); btn.disabled = true; busyOn();   // P-098
      var keys = [];
      var secIds = cartSections(), sectionsHtml = null;
      if (secIds.length) { fd.set('sections', secIds.join(',')); fd.set('sections_url', window.location.pathname + window.location.search); }
      var addMain = function () {
        return phPost(C.routes.cartAdd, fd, T).then(function (j) { sectionsHtml = j.sections || null; return j; });   // P-102: XHR = upload progress
      };
      var rollback = function () {   // one request removes every extra line added in step 1
        if (!keys.length) return Promise.resolve();
        var up = {}; keys.forEach(function (k) { up[k] = 0; });
        return postJSON(C.routes.root.replace(/\/$/, '') + '/cart/update.js', { updates: up }).catch(function () {});
      };
      var step1 = items.length ? postJSON(C.routes.cartAdd + '.js', { items: items }).then(function (j) { keys = (j.items || []).map(function (x) { return x.key; }); }) : Promise.resolve();
      var slims = Object.keys(S.photos).map(function (k) { return S.photos[k] ? [upEls(k).input.name, S.photos[k]] : null; }).filter(Boolean);   // P-102
      Promise.all([step1, phUpFd(fd, slims, T).then(function (rest) { return phSlimFd(fd, rest); })]).then(function () {   // P-102b: pre-uploaded photos go as their URL
        return addMain().catch(function (err) { return rollback().then(function () { throw err; }); });
      }).then(function () {
        S.tried = false;
        $('[data-ph-added]').innerHTML = esc(T.addedToBag) + ' <a href="' + esc(C.routes.cart) + '">' + esc(T.viewBag) + ' ›</a>';
        notifyTheme([{ merchandiseId: String(v.id), quantity: 1 }].concat(items.map(function (x) { return { merchandiseId: String(x.id), quantity: x.quantity }; })), sectionsHtml);
        document.dispatchEvent(new CustomEvent('ph:cart:added', { detail: { variant: v && v.id, pair: items.length ? pair : null } }));
        busyOff(true);   // P-098: the drawer keeps "Adding…" until the lines show
      }).catch(function () {
        busyOff(false); $('[data-ph-added]').textContent = '';
        $('[data-ph-error]').innerHTML = '<b>' + esc(T.errGeneric) + '</b>';
      }).then(function () { btn.disabled = false; });
    }
    function submit() {
      if (S.adding) return;   // P-098: one add at a time (the sticky button was never locked)
      $('[data-ph-added]').textContent = '';
      S.tried = true;
      var list = problems();
      showErrors(list, true);
      if (list.length) { focusField(document.getElementById(list[0].id)); return; }
      addToBag();
    }
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); submit(); });

    /* ---------- waitlist (native contact form; client checks only) ---------- */
    var wl = $('[data-ph-wl]');
    if (wl) wl.addEventListener('submit', function (e) {
      var em = $('[data-ph-wl-email]'), ok = $('[data-ph-wl-consent]');
      if (!em || !ok) return;
      var emOk = em.value && em.checkValidity();
      document.getElementById(em.getAttribute('aria-describedby')).textContent = emOk ? '' : T.wlEmail;
      em.setAttribute('aria-invalid', !emOk);
      document.getElementById(ok.getAttribute('aria-describedby')).textContent = ok.checked ? '' : T.wlConsent;
      ok.setAttribute('aria-invalid', !ok.checked);
      if (!emOk) { e.preventDefault(); em.focus(); return; }
      if (!ok.checked) { e.preventDefault(); ok.focus(); }
    });

    /* ---------- sticky bar (mobile) ---------- */
    var sticky = $('[data-ph-sticky]'), stBtn = $('[data-ph-st-btn]');
    var target = $('[data-ph-add]') || $('[data-ph-wl]');
    if (sticky && target && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        var show = !es[0].isIntersecting && es[0].boundingClientRect.top > 0;   // breed PDP: only while the button is still below
        sticky.classList.toggle('is-shown', show); sticky.setAttribute('aria-hidden', !show); stBtn.tabIndex = show ? 0 : -1;
      }).observe(target);
    }
    if (stBtn) stBtn.addEventListener('click', function () {
      if (C.waitlist) { var em = $('[data-ph-wl-email]'); if (em) { em.scrollIntoView({ block: 'center', behavior: reduced ? 'auto' : 'smooth' }); em.focus({ preventScroll: true }); } }
      else submit();
    });

    /* ---------- accordion openers ---------- */
    $$('[data-ph-open]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        var d = document.getElementById(b.dataset.phOpen); if (!d) return;
        e.preventDefault(); d.open = true;
        d.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
        d.querySelector('summary').focus({ preventScroll: true });
      });
    });

    /* ---------- ad-link parameters: ?material=YG&faces=3&with=chain&length=20 ---------- */
    (function applyParams() {
      var qs = new URLSearchParams(window.location.search);
      if (pos.metal && qs.has('material')) {
        var val = (C.materialCodes || {})[String(qs.get('material')).trim().toUpperCase()] || C.materialFallback;   // SG / unknown -> fallback (925)
        $$('[data-ph-opt="' + pos.metal + '"]').forEach(function (el) { if (el.value === val) el.checked = true; });
      }
      var cp = C.kind === 'necklace' ? 'faces' : C.kind === 'bracelet' ? 'medallions' : null;
      if (cp && qs.has(cp) && C.countMax > 1) {
        var nn = parseInt(qs.get(cp), 10);
        if (!(nn >= 1 && nn <= C.countMax) || !supports(metalName(), nn)) nn = 1;   // invalid or above the material's max -> 1
        setCount(nn);
      }
      if (xsOn && qs.get('with') === 'chain') {
        xsOn.checked = true;
        if (C.xs.lenPos && qs.has('length')) {
          var L = String(qs.get('length')).trim();
          $$('[data-ph-xs-len]').forEach(function (el) { if (el.value.indexOf(L + '"') === 0) el.checked = true; });
        }
      }
    })();
    paintXs();
    applyCount(); applyMetalSlides(); paintDeltas(); paintLimits(); paintPriceRow(); paintIllus(); renderThumbs(); update();
  }

  function boot(scope) { Array.prototype.forEach.call((scope || document).querySelectorAll('[data-ph-product]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
